function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10.93 2.07a.243.243 0 00-.18-.07H8.336L7.79.695a1.083 1.083 0 00-.422-.492A1.104 1.104 0 006.75 0h-2.5c-.208 0-.414.068-.617.203s-.344.3-.422.492L2.664 2H.25a.244.244 0 00-.18.07.244.244 0 00-.07.18v.5c0 .073.023.133.07.18.047.046.107.07.18.07H1v7.438c0 .432.122.8.367 1.105.245.305.54.457.883.457h6.5c.344 0 .638-.158.883-.473.245-.315.367-.688.367-1.12V3h.75a.243.243 0 00.18-.07.244.244 0 00.07-.18v-.5a.243.243 0 00-.07-.18zm-6.797-.984A.22.22 0 014.266 1h2.476a.22.22 0 01.133.086L7.25 2h-3.5l.383-.914zM9 10.406a.885.885 0 01-.168.528c-.039.044-.066.066-.082.066h-6.5c-.016 0-.043-.022-.082-.066A.888.888 0 012 10.407V3h7v7.406z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.25 9.5h.5a.243.243 0 00.18-.07.244.244 0 00.07-.18v-4.5a.244.244 0 00-.07-.18.244.244 0 00-.18-.07h-.5a.244.244 0 00-.18.07.244.244 0 00-.07.18v4.5c0 .073.023.133.07.18.047.047.107.07.18.07zM5.25 9.5h.5a.243.243 0 00.18-.07.243.243 0 00.07-.18v-4.5a.243.243 0 00-.07-.18.243.243 0 00-.18-.07h-.5a.244.244 0 00-.18.07.243.243 0 00-.07.18v4.5c0 .073.023.133.07.18.047.047.107.07.18.07zM7.25 9.5h.5a.243.243 0 00.18-.07.244.244 0 00.07-.18v-4.5a.244.244 0 00-.07-.18.244.244 0 00-.18-.07h-.5a.244.244 0 00-.18.07.244.244 0 00-.07.18v4.5c0 .073.024.133.07.18.047.047.107.07.18.07z"
});

function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 11 12",
    fill: "currentColor"
  }, props), _ref, _ref2);
}

export default SvgTrash;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/trash.svg
// module id = 1294
// module chunks = 10